define('lq/events/actions/copyToClipboard',[
    'lq/events/actions/eventAction',
    'lq/clipboard'
], function (EventAction, clipboard) {
    'use strict';

    function CopyToClipboard(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        return this;
    }

    EventAction.extend(CopyToClipboard, EventAction);

    CopyToClipboard.typeName = 'CopyToClipboard';

    CopyToClipboard.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };

    CopyToClipboard.prototype.execute = function (continuation) {
        clipboard.copy(this.getValueToCopy());

        continuation();
    };

    CopyToClipboard.prototype.getValueToCopy = function() {
        if (this.eventData.source === 'viewmodel') {
            var sourceMorph = this.piping.dropFactory.findDropByViewModelKey(this.eventData.viewModelKey);
            return sourceMorph.getValue();
        }

        return this.piping.parameters.getValue(this.eventData.parameter);
    };

    return CopyToClipboard;
});
